import ReactApexChart from "react-apexcharts";

export default function DurationChart({ labels, values }) {
  return (
    <ReactApexChart
      type="bar"
      height={200}
      series={[{ name: "Calls", data: values }]}
      options={{
        chart: {
          type: "bar",
          height: 200,
          toolbar: { show: false },
          fontFamily: "'Outfit', sans-serif",
          background: "transparent",
        },
        xaxis: { categories: labels },
        colors: ["#18A0D8"],
        plotOptions: {
          bar: { horizontal: true, borderRadius: 6, barHeight: "55%" },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            opacityFrom: 1,
            opacityTo: 0.7,
          },
        },
        dataLabels: { enabled: true, style: { fontSize: "11px" } },
        grid: { borderColor: "#e8f2f7" },
        tooltip: { theme: "light" },
      }}
    />
  );
}
